import classnames from 'classnames/bind'
import React, { useState } from 'react'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'

import InlineCta from '~/components/UI/InlineCta'

import { CTA } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type ReadMoreTextProps = {
  className?: string
  text?: string
  charsLimit?: number
  hasReadLess?: boolean
}

function ReadMoreText({
  className,
  text,
  charsLimit,
  hasReadLess,
}: ReadMoreTextProps) {
  const t = useTranslate()
  const [isOpen, setIsOpen] = useState(false)

  const isTruncated = text && text.length > charsLimit
  const truncatedText = isTruncated ? `${text.slice(0, charsLimit)}...` : text
  const shouldShowButton = hasReadLess ? isTruncated : isTruncated && !isOpen

  return (
    <div className={cx(css.ReadMoreText, className)}>
      <p className={cx(css.truncatedText)}>
        <span className={css.textItem}>{isOpen ? text : truncatedText}</span>
        {shouldShowButton && (
          <InlineCta
            textPreset={GlobalTextPreset.Cta12Grotesk}
            className={css.descriptionCta}
            theme={GlobalThemeColors.Black}
            onClick={() => setIsOpen(!isOpen)}>
            {t(isOpen ? CTA.READ_LESS : CTA.READ_MORE)}
          </InlineCta>
        )}
      </p>
    </div>
  )
}

ReadMoreText.defaultProps = {
  hasReadLess: true,
}

export default ReadMoreText
